import * as squint_core from 'squint-cljs/core.js';
var debounced = function (delay_ms, f) {
const timer_id_1 = squint_core.atom(null);
return /* @__PURE__ */ (() => {
const impl11333_2 = (function (args) {
if (squint_core.truth_(squint_core.deref(timer_id_1))) {
clearTimeout(squint_core.deref(timer_id_1))};
return squint_core.reset_BANG_(timer_id_1, setTimeout((function () {
return squint_core.apply(f, args);

}), delay_ms));

});
const f11331 = (function (...rest11332) {
const self__10030__auto___3 = this;
return impl11333_2.call(self__10030__auto___3, (((rest11332.length === 0)) ? (null) : (rest11332)));

});
(f11331["squint$lang$variadic"] = impl11333_2);
return f11331;

})();

};

export { debounced }
